import * as React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';


const { EFPic } = createEFPic('/media/rivermini/h5/');
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAppProps {}

const App: React.FunctionComponent<IAppProps> = (props) => {
    const { useLang } = useGlobal();
    const { t } = useLang('riverminiportablepowerstation');

    return (
        <>
            <section className={`river-mini-overview ${css.OverView}`}>
                <article className="grid-content">
                    <div className="view-item view-item-1">
                        <EFPic name={['RIVER_mini_M_01.webp', 'RIVER_mini_M_01.png']} />
                    </div>
                    <div className="view-item view-item-2">
                        <EFPic
                            name={['RIVER_mini_M_02.webp', 'RIVER_mini_M_02.png']}
                            alt={t('river_mini.ytdd_sec4_tit1')}
                            aria-label={t('river_mini.ytdd_sec4_tit1')}
                        />
                        <span className="text">{t('river_mini.ytdd_sec4_tit1')}</span>
                        <span className="text">{t('river_mini.ytdd_sec4_tit2')}</span>
                    </div>
                    <div className="view-item view-item-3">
                        <EFPic
                            name={['RIVER_mini_M_03.webp', 'RIVER_mini_M_03.png']}
                            alt={t('river_mini.ytdd_sec3_tit2')}
                            aria-label={t('river_mini.ytdd_sec3_tit2')}
                        />
                        <span className="text">{t('river_mini.ytdd_sec3_tit2')}</span>
                    </div>
                    <div className="view-item view-item-4">
                        <EFPic
                            name={['RIVER_mini_M_04.webp', 'RIVER_mini_M_04.png']}
                            alt={t('river_mini.ytdd_sec2-top_tit2')}
                            aria-label={t('river_mini.ytdd_sec2-top_tit2')}
                        />
                        <span className="text">{t('river_mini.ytdd_sec2-top_tit2')}</span>
                    </div>
                    <div className="view-item view-item-5">
                        <EFPic
                            name={['RIVER_mini_M_05.webp', 'RIVER_mini_M_05.png']}
                            alt={t('river_mini.ytdd_sec2-btm_tit')}
                            aria-label={t('river_mini.ytdd_sec2-btm_tit')}
                        />
                        <span className="text">{t('river_mini.ytdd_sec2-btm_tit')}</span>
                    </div>
                    <div className="view-item view-item-6">
                        <EFPic
                            name={['RIVER_mini_M_06.webp', 'RIVER_mini_M_06.png']}
                            alt={t('river_mini.ytdd_sec5_tit')}
                            aria-label={t('river_mini.ytdd_sec5_tit')}
                        />
                        <span className="text">{t('river_mini.ytdd_sec5_tit')}</span>
                    </div>
                </article>
            </section>
        </>
    );
};

export default App;
